<template>

  <!-- @click="usuarioEdit"  -->
  <v-row >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="800px"
    >
 <template v-slot:activator="{ on, attrs }">

   <v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

   <v-row>
       <v-col cols="12" sm="12" lg="12" class="d-flex justify-end">
       
       <v-btn
       class="pb-2"
       color="blue darken-4" 
       v-bind="attrs"
          v-on="on"
          data-cy="add-usuario-input"
     

       text
       >
       
         ¿Olvidó su contraseña?
       </v-btn>

       </v-col>

   </v-row>
       
      </template>


      <v-card>
         <v-card-title class="text-h5" >
      Recuperación de acceso

      <!-- {{this.usuario}} -->
    </v-card-title>
        
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="12" lg="10" class="text-justify">
          
            Para cambiar su contraseña, envíe su dirección de usuario electrónico. Si podemos encontrarlo en la base de datos, le enviaremos un email con instrucciones para poder acceder de nuevo.
          
        </v-col>
      </v-row>
    </v-container>
        
<v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                

                <v-card-text>
               <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
   
    <v-text-field
           v-model="usuario.email"
           label="Correo"
           :counter="3"
           :rules="emailRules"
           required
         ></v-text-field>


    </v-form> 
            </v-card-text>
               


              </v-col>
              
            </v-row>
          </v-container>
        </v-card-text>


        - <v-card-actions>
           <v-spacer></v-spacer>
            <v-btn  outlined color="red darken-1"  text  @click="dialog = false">
               <v-icon>
       mdi-cancel
      </v-icon> 
              Cerrar ventana
            </v-btn>
            <v-btn outlined color="blue darken-4" 
            text @click="enviarCorreo"
            data-cy="submit"
            >
            <v-icon>
       mdi-email-outline
      </v-icon> 
              Enviar Correo
            </v-btn>
        </v-card-actions>  
      </v-card>




    </v-dialog>
  </v-row>
</template>



<script>



import loginService from "@/services/loginService.js";

//import { useRecaptchaV3 } from "vue-recaptcha-v3";

//import { VueReCaptchaV3 } from 'vue-recaptcha-v3'


 
export default {

 
 
  data: vm => ({
  //<td v-on:click="guardarUsuario(usuario)">{{usuario.name}}</td>
  tokenRe:'',
  valid: true,
    dialog:false,
 showPass: false,
   
      valid: false,
      mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: -1,
      },
    usuario:{
email:'',
recaptcha:''
        },
  
    rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                 
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 1) || "Debe contener al menos 3 caracteres",
            ],
        
            emailRules:  [
              (v) => !!v || "Correo es requerido",
              (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
            ],
             numberRules: [
              (v) => (v >= 0) || "Valor debe ser mayor o igual a 0",
            ],
  }),
  components:{
     
  },
  mounted() {

  
   // this.recaptcha();
   

    
  },
  methods: {

    async recaptcha() {
  try {
    
    await this.$recaptchaLoaded();

    const token = await this.$recaptcha('login');

    
    return token;
  } catch (error) {
    console.error('Error al ejecutar reCAPTCHA:', error);
    throw error; 
  }
}
,

  async  enviarCorreo(){


    try {
    const token = await this.recaptcha(); // Espera hasta que recaptcha() termine
    //console.log('Token obtenido:', token);
          this.usuario.recaptcha=token;

        } catch (error) {
    console.error('Error en reCAPTCHA:', error);
  }

      console.log(this.usuario.email);

            if (this.$refs.form.validate()) {

                console.log("Formulario Validado");




           console.log('en metodo');
           console.log(this.usuario);
                loginService.enviarCorreo(this.usuario).then(
        response =>{
       

          console.log(response);
            console.log('success');

            console.log(response.data.message);

             this.mensaje.text="Verifique su correo electrónico para finalizar la operación";

             this.mensaje.color="primary";
      this.mensaje.colorBtn="blue";

      this.mensaje.snackbar="true";


          
        }).catch((errors) =>{
//errors.message

        //  console.log("Ingrese en error al enviar");
        //  console.log(errors.message);
         
        //  console.log(errors.response.data.message);
     

          let mensajeError = '';

          mensajeError += "\n"+""+errors.response.data.message;

            this.mensaje.text=mensajeError;

      this.mensaje.snackbar="true";

      this.mensaje.color="error";
      this.mensaje.colorBtn="error";
        
           console.log('error');
            console.log(errors);


           
        })

 
      


            }


        },
    validate(){
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
    ,
    limpiar(){

     
		this.usuario={
				email:''
	}}
  ,
    recibirUsuario:function(usuarioOpcion){

      console.log('En elemento padre Usuario');
        console.log(usuarioOpcion);
     

    }

  
  
  },//fin methos

    watch: {
      date (val) {
        
			
		
       
      },
    },




}



    
  
</script>

